var render = function render(){var _vm=this,_c=_vm._self._c;return _c('aside',[_c('TypographyConfig'),_c('ColorSwatch')],1)
}
var staticRenderFns = []

export { render, staticRenderFns }